import { P2GBox } from '@parcel2go/core-ui';
import { ILinkProps, P2GLink } from '@parcel2go/core-ui';
import { P2GLinkGroup } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { Suspense, useCallback, useContext, useMemo, useState } from 'react';
import { SmartSendContext } from '../../lib/context/SmartSendContext';
import { ToggleSelectionAllItemsAction } from '../../lib/context/SmartSendContextModels';
import { PanelButtons } from './panels/PanelButtons';

import QuickSelect from './quickselect/QuickSelect';
import { P2GSidePanel } from '~/components/sidepanel';
import { P2GImageMessage } from '~/components/imagemessage';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  selected: number;
  total: number;
  filterKey: string;
}

export default function SmartSendSoldHeaderRowXs(props: props) {
  const ctx = useContext(SmartSendContext);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const [open, setOpen] = useState(false);
  const setToggleAll = useCallback(
    (val: boolean) => ctx.dispatch(new ToggleSelectionAllItemsAction(props.filterKey, val)),
    [ctx, props.filterKey]
  );

  const links = useMemo(() => {
    const output: ILinkProps[] = [
      <P2GLink onClick={() => setOpen(true)} variant="body2" key="selected-items-link">
        {props.selected === 1
          ? t('1_ITEM_SELECTED', '1 Item Selected')
          : t('N_ITEMS_SELECTED', '{{count}} Items Selected', { count: props.selected })}
      </P2GLink>
    ];

    if (props.selected < props.total) {
      output.push(
        <P2GLink variant="body2" key="select-all-link" onClick={() => setToggleAll(true)}>
          {t('SELECT_ALL_LINK', 'Select All')}
        </P2GLink>
      );
    }

    if (props.selected > 0) {
      output.push(
        <P2GLink variant="body2" key="clear-selection-link" onClick={() => setToggleAll(false)}>
          {t('CLEAR_SELECTION_LINK', 'Clear')}
        </P2GLink>
      );
    }

    return output;
  }, [props.selected, props.total, setToggleAll, t]);

  return (
    <>
      <P2GBox textAlign="center">
        <P2GLinkGroup links={links} />
      </P2GBox>
      <P2GSidePanel open={open} onClose={() => setOpen(false)} anchor="bottom">
        {open && (
          <>
            <P2GImageMessage
              image="/theme/smartsend/notifications/quickselect.png"
              contentKey="image-smartsend-quickselect-xs"
            >
              <P2GText>
                Quick Select orders to
                <br />
                book or apply bulk actions.
                <br />(<strong>{props.selected} Selected</strong>)
              </P2GText>
            </P2GImageMessage>
            <P2GBox pb={2}>
              <Suspense>
                <QuickSelect filterKey={props.filterKey} restrictToSold={true} selected={props.selected} isXs={true} />
              </Suspense>
            </P2GBox>
            <PanelButtons onCancel={() => setOpen(false)} cancelText="View Items" />
          </>
        )}
      </P2GSidePanel>
    </>
  );
}
